module.exports = __webpack_public_path__ + "static/media/Олими А.Г., Охунов Н.К..7e098275.pdf";